import { mergeAll } from 'ramda';

import { isAuxValueUnused } from '../utils/utils';

import { AuxValue, getAuxValueById } from 'RestAPIs/AuxiliaryValues';

import useResource from 'components/shared/hooks/useResource';

import { AuxFormValues } from '../Form/AuxValuesForm.types';

const getAuxFormValues = (auxValue: AuxValue): AuxFormValues => {
  return {
    auxValueId: auxValue.auxValueId,
    code: auxValue.code,
    colorCode: auxValue.colorCode,
    auxValueGroupId: auxValue.auxValueGroupId,
    auxValueGroupName: auxValue.auxValueGroupName,
    notInUse: isAuxValueUnused(auxValue.flags),
    sortOrder: auxValue.sortOrder,

    //@ts-ignore
    translations: mergeAll(
      auxValue.translations.map((item) => {
        return { [item.languageCode]: item.name };
      })
    )
  };
};

const useGetAuxValueById = (id: number) => {
  const { resource, isFetching } = useResource({
    fetcher: () => getAuxValueById(id),
    transformer: (response) => {
      return getAuxFormValues(response);
    }
  });

  return { resource: resource ? resource : undefined, isFetching };
};

export default useGetAuxValueById;
